import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LoginForm from './component/login/LoginForm';
import SignupForm from './component/signup/SignupForm';
import Header from './component/header/header';
import Dashboard from './component/dashboard/Dashboard';

import Sidebar from "./component/sidemenu/Sidebar";
import { AuthProvider } from './component/common/AuthContext';

import Subscribe from "component/subscribe/Subscribe";
import Profile from "component/profile/Profile";
import usePageTitle from "component/common/PageTitle";
import AccountVerified from "component/account-verified/AccountVerified";
import StockapiDayRangeData from "component/nse/stock/stock-day-range-data/StockDayRangeData";
import FifthStrikeOptionChain from "component/nse/fifthstrike/FifthStrikeOptionChain";
import NseOptionChain from "component/nse/option-chain/NseOptionChain";
import DayRangeAnalysis from "component/nse/day-range-analysis/DayRangeAnalysis";
import OptionStrikeBars from "component/nse/test/OptionStrikeBars";
import OIDataAnalysis from "component/nse/oi-oichg-analysis/OIDataAnalysis";
import BidAskBars from "component/nse/test/BidAskBars";
import StockDataAnalysis from "component/nse/stock/stock-data-analysis/StockDataAnalysis";
import CryptoApiOptionChain from "component/crypto/CryptoApiOptionChain";
import ForgotPassword from "component/forgot-password/ForgotPassword";
import FyersAccesstoken from "component/fyers-token/FyersAccessToken";
import StockSectorDataAnalysis from "component/nse/stock/stock-sector-analysis/StockSectorDataAnalysis";
import ChartData from "component/nse/tradingview-chart/ChartData";
import GreeksCalculation from "component/nse/GreeksCalculation/GreeksCalculation";
import OptionChainAnalysis from "component/nse/option-chain-analysis/OptionChainAnalysis";
import SectorialIndices from "component/nse/stock/sectorial-indices/SectorialIndices";
import ProtectedRoute from "component/common/ProtectedRoute";
import GlobalMarketData from "component/nse/global-market/GlobalMarketData";
import FIIDIISummaryData from "component/nse/fii-dii/summary/FIIDIISummaryData";
import "react-datepicker/dist/react-datepicker.css";
function Layout() {
  const location = useLocation();

  // Hide Header for dashboard and nifty-option-chain routes
  // const hideHeader = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/nifty-option-chain");
  const hideHeader = location.pathname.startsWith("/profile-option-chain") || location.pathname.startsWith("/stock-api-day-range-data")
    || location.pathname.startsWith("/fifth-strike-option-chain") || location.pathname.startsWith("/nse-option-chain") || location.pathname.startsWith("/day-range-analysis")
    || location.pathname.startsWith("/oi-data-analysis") || location.pathname.startsWith("/option-bar") || location.pathname.startsWith("/bars")
    || location.pathname.startsWith("/stock-sector-analysis") || location.pathname.startsWith("/stock-data-analysis") || location.pathname.startsWith("/crypto-option-chain")
    || location.pathname.startsWith("/fyers-access-token") || location.pathname.startsWith("/option-chain-analysis")
    || location.pathname.startsWith("/chart") || location.pathname.startsWith("/greeks") || location.pathname.startsWith("/sectorial-indices")
    || location.pathname.startsWith("/global-data") || location.pathname.startsWith("/fii-dii");

  const login = location.pathname.startsWith("/login") || location.pathname.startsWith("/signup") || location.pathname.startsWith("/verified")
    || location.pathname.startsWith("/forgot-password") || location.pathname === "/";
  // Show Sidebar for dashboard and nifty-option-chain routes
  // const showSidebar =  location.pathname.startsWith("/nifty-option-chain");
  usePageTitle();
  return (
    <>
      {!hideHeader && <Header />}
      {!login && <Sidebar />}
      {/* <Header /> */}

      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/signup" element={<SignupForm />} />
        
        <Route path="/verified/*" element={<AccountVerified />} />

        {/* Protected Routes */}
        <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/subscribe/*" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
        <Route path="/profile/*" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/stock-api-day-range-data/*" element={<ProtectedRoute><StockapiDayRangeData /></ProtectedRoute>} />
        <Route path="/fifth-strike-option-chain/*" element={<ProtectedRoute><FifthStrikeOptionChain /></ProtectedRoute>} />
        <Route path="/nse-option-chain/*" element={<ProtectedRoute><NseOptionChain /></ProtectedRoute>} />
        <Route path="/day-range-analysis/*" element={<ProtectedRoute><DayRangeAnalysis /></ProtectedRoute>} />
        <Route path="/oi-data-analysis/*" element={<ProtectedRoute><OIDataAnalysis /></ProtectedRoute>} />
        <Route path="/option-bar/*" element={<ProtectedRoute><OptionStrikeBars /></ProtectedRoute>} />
        <Route path="/bars/*" element={<ProtectedRoute><BidAskBars /></ProtectedRoute>} />
        <Route path="/stock-data-analysis/*" element={<ProtectedRoute><StockDataAnalysis /></ProtectedRoute>} />
        <Route path="/stock-sector-analysis/*" element={<ProtectedRoute><StockSectorDataAnalysis /></ProtectedRoute>} />
        <Route path="/crypto-option-chain/*" element={<ProtectedRoute><CryptoApiOptionChain /></ProtectedRoute>} />
        <Route path="/fyers-access-token/*" element={<ProtectedRoute><FyersAccesstoken /></ProtectedRoute>} />
        <Route path="/option-chain-analysis/*" element={<ProtectedRoute><OptionChainAnalysis /></ProtectedRoute>} />
        <Route path="/chart/*" element={<ProtectedRoute><ChartData /></ProtectedRoute>} />
        <Route path="/greeks/*" element={<ProtectedRoute><GreeksCalculation /></ProtectedRoute>} />
        <Route path="/sectorial-indices/*" element={<ProtectedRoute><SectorialIndices /></ProtectedRoute>} />
         <Route path="/global-data/*" element={<ProtectedRoute><GlobalMarketData /></ProtectedRoute>} />
         <Route path="/fii-dii/*" element={<ProtectedRoute><FIIDIISummaryData /></ProtectedRoute>} />

        {/* Default */}
        <Route path="*" element={<LoginForm />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout />
      </Router>
    </AuthProvider>
  );
}
